// libraries
import styled, { keyframes } from 'styled-components';

const indeterminate = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(250%); }
`;

export const StyledCreate = styled.div`
  padding: 24px 28px;

  .create-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px;
  }

  .create-desc {
    font-size: 13px;
    color: var(--color-text-gray);
    margin: 0 0 16px;
  }

  .modeling-stage {
    font-size: 15px;
    font-weight: 600;
    color: var(--color-charcoal-black);
    margin: 24px 0 12px;

    &.is-failed {
      color: var(--color-error, #d64545);
    }
  }

  .modeling-progress-bar {
    height: 6px;
    border-radius: 3px;
    background: var(--color-pale-gray);
    overflow: hidden;
    position: relative;

    &-fill {
      height: 100%;
      background: var(--color-menu-selected);
      transition: width 0.3s ease;
    }

    &-fill.is-indeterminate {
      position: absolute;
      width: 40%;
      animation: ${indeterminate} 1.2s ease-in-out infinite;
    }
  }

  .modeling-caption {
    margin-top: 12px;
    font-size: 13px;
    color: var(--color-primary-blue);
  }
`;
